import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UserGender } from 'types/enums/UserGender';
import { UserProfile } from 'types/interfaces/user/UserProfile';

interface ProfileState {
  profile: UserProfile;
}

const initialState: ProfileState = {
  profile: {
    id: 0,
    username: '',
    age: 25,
    gender: UserGender.Male,
    photo_count: 1,
    city: null,
    photos: [],
    videos: [],
    liked: false,
    is_additional_info_hidden: false,
    is_popular: false,
    videos_access: [],
    can_view: false,
    details: null,
  },
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setProfile(state, action: PayloadAction<UserProfile>) {
      state.profile = action.payload;
    },
  },
});

export const { setProfile } = profileSlice.actions;

export const profile = profileSlice.reducer;
